<template>
  <div class="about">
    <siteHeader />
    
    <!-- 轮播图区域 -->
    <div class="slider-container">
      <div class="slider">
        <div class="slide">
          <el-carousel
            height="400px"
            :interval="3000"
            trigger="hover"
            :autoplay="true"
            v-if="bannerList.length"
            indicator-position="outside">
            <el-carousel-item v-for="item in bannerList" :key="item.id">
              <div class="slide-content" :style="{ backgroundImage: `url(${item.url})` }"></div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    
    <div class="content">
      <div class="container">
        <page-breadcrumb :paths="['学院概况', currentSection]" />
        
        <div class="page-content">
          <div class="left-nav">
            <h3>学院概况</h3>
            <ul>
              <li 
                v-for="section in sections" 
                :key="section.name"
                :class="{ active: currentSection === section.name }"
                @click="scrollToSection(section.id)"
              >
                {{ section.name }}
              </li>
            </ul>
          </div>

          <div class="right-content">
            <div id="introduction" class="section" ref="学院介绍">
              <div class="banner">
                <img src="../assets/aboutTop.png" alt="学院概况" class="banner-image">
              </div>
              <!-- <h2>学院介绍</h2> -->
              
              <!-- <div class="introduction">
                <div class="text-content">
                  <div class="section-title">
                    <h3>拓见高远 诚达天下</h3>
                    <p class="subtitle">Open the eyes<br>and reach the world</p>
                  </div>
                  <p>重庆市拓诚职业培训学院的前身为在2006年重大B区成立的重庆英华重大职业教育学院，2019年迁至大学城北路并正式更名为重庆市拓诚职业培训学院（简称拓诚职院），2024年迁至渝北区仙桃街道重庆新闻传媒大厦。是经重庆市人社局批准设立、市民政局登记注册的民办非盈利性机构。拓诚职院是重庆市报业传媒协会会员单位，职院目前重点开展消防专业人员、档案专业人员、新闻专业人员等专业技术（技能）培训，为相关企业和个人提供专业、权威的学习成长平台，每年为国家和社会培养能工巧匠。</p>
                </div>
              </div> -->
            </div>

            <div id="gallery" class="section" ref="学院风采">
              <!-- <h2>学院历程</h2> -->
              <div class="gallery">
                <img src="../assets/aboutFoot.png" alt="学院历程" class="full-width-image" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <siteFooter />
  </div>
</template>

<script>
import PageBreadcrumb from '@/components/Breadcrumb.vue'
import siteHeader from '../components/SiteHeader.vue'
import siteFooter from '../components/SiteFooter.vue'
import { websiteApi } from "@/api";

export default {
  name: 'AboutPage',
  components: {
    'page-breadcrumb': PageBreadcrumb,
    siteHeader,
    siteFooter
  },
  data() {
    return {
      currentSection: '学院介绍',
      sections: [
        { name: '学院介绍', id: 'introduction' },
        { name: '学院风采', id: 'gallery' }
      ],
      aboutContent: '',
      galleryImages: [],
      bannerList: []
    }
  },
  async created() {
    // 获取轮播图数据
    await this.getTopBanners();
    
    // 初始加载所有内容
    await this.fetchContent(13); // 学院介绍
    await this.fetchContent(14); // 学院风采
    
    // 检查URL中是否有tab参数
    const tab = this.$route.query.tab;
    if (tab) {
      const foundSection = this.sections.find(s => s.name === tab);
      if (foundSection) {
        this.currentSection = foundSection.name;
        this.$nextTick(() => {
          this.scrollToSection(foundSection.id, false);
        });
      }
    }
  },
  mounted() {
    // 添加滚动事件监听
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听（使用beforeDestroy而不是beforeUnmount以兼容Vue 2）
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      // 简单的滚动检测方法
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // 获取章节元素和位置
      const introEl = document.getElementById('introduction');
      const galleryEl = document.getElementById('gallery');
      
      if (!introEl || !galleryEl) return;
      
      // const introTop = introEl.offsetTop;
      const galleryTop = galleryEl.offsetTop;
      
      // 预留一些偏移量以提前激活
      const offset = 100;
      
      // 确定当前章节
      if (scrollTop >= galleryTop - offset) {
        if (this.currentSection !== '学院风采') {
          this.currentSection = '学院风采';
        }
      } else {
        if (this.currentSection !== '学院介绍') {
          this.currentSection = '学院介绍';
        }
      }
    },
    async getTopBanners() {
      try {
        const res = await websiteApi.getPictureList();
        if (res.code === 200) {
          // 筛选出 location 为 1 的轮播图数据
          this.bannerList = res.rows
            .filter(item => item.location === 1)
            .map((item) => ({
              id: item.id,
              url: item.carouselUrl,
              title: "",
              subtitle: "",
              description: item.remark || "",
            }));
            
          // 如果没有符合条件的数据，使用默认图片
          if (this.bannerList.length === 0) {
            this.bannerList = [
              { id: 1, url: require('../assets/aboutTop.png') }
            ];
          }
        }
      } catch (error) {
        console.error("获取顶部轮播图失败：", error);
        // 发生错误时使用默认图片
        this.bannerList = [
          { id: 1, url: require('../assets/aboutTop.png') }
        ];
      }
    },
    async fetchContent(categoryId) {
      try {
        const response = await websiteApi.getTcTrainArticle({ categoryId })
        if (response?.code === 200 && response?.rows?.length > 0) {
          if (categoryId === 13) {
            // We're not setting aboutContent anymore since it's hardcoded
            // this.aboutContent = response.rows[0].contents
          } else if (categoryId === 14) {
            this.galleryImages = response.rows.map(item => ({
              cover: item.cover,
              title: item.title
            }))
          }
        }
      } catch (error) {
        console.error('获取内容失败:', error)
      }
    },
    scrollToSection(sectionId, updateUrl = true) {
      const section = document.getElementById(sectionId);
      if (section) {
        // 找到对应的section名称
        const foundSection = this.sections.find(s => s.id === sectionId);
        if (foundSection) {
          this.currentSection = foundSection.name;
        }
        
        // 滚动到对应位置，顶部留出一些空间
        const offset = 80; // 顶部偏移量，根据实际需要调整
        const top = section.offsetTop - offset;
        
        window.scrollTo({
          top: top,
          behavior: 'smooth'
        });
        
        // 更新URL
        if (updateUrl) {
          this.$router.push({ query: { tab: foundSection.name } });
        }
      }
    }
  }
}
</script>

<style scoped>
/* 轮播图样式 */
.slider-container {
  position: relative;
  height: 400px;
  background-color: transparent;
  overflow: hidden;
}

.slider {
  width: 100%;
  height: 100%;
}

.slide {
  position: relative;
  width: 100%;
  height: 100%;
}

.slide-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
}

/* 主内容区样式 */
.content {
  padding: 20px 0 40px 0;
  min-height: calc(100vh - 60px - 400px); /* 减去头部和轮播图的高度 */
  background: transparent;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.banner {
  width: 100%;
  height: auto;
  overflow: visible;
  margin: 20px 0;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.banner-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

.page-content {
  display: flex;
  gap: 30px;
  margin-top: 20px;
}

.left-nav {
  width: 200px;
  background: transparent;
  padding: 20px;
  border-radius: 4px;
  /* box-shadow: 0 2px 4px rgba(0,0,0,0.05); */
  position: sticky;
  top: 80px;
  align-self: flex-start;
  max-height: calc(100vh - 160px);
  overflow-y: auto;
  color:#dddddd
}

.left-nav h3 {
  margin: 0 0 15px 0;
  padding-bottom: 10px;
  /* border-bottom: 2px solid #1e88e5; */
  color: #333;
}

.left-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.left-nav li {
  padding: 12px 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 4px;
}

.left-nav li:hover {
  background: #e3f2fd;
  /* color: #1e88e5; */
}

.left-nav li.active {
  /* background: #1e88e5; */
  color: #0b0b0b;
}

.right-content {
  flex: 1;
}

.section {
  background: transparent;
  padding: 30px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  margin-bottom: 30px;
}

.right-content h2 {
  margin: 0 0 20px 0;
  color: #000000;
  padding-bottom: 10px;
  font-size: 12px;
  border: 1px solid #d8d8d8;
  display: inline-block;
  padding: 8px 15px;
  border-radius: 15px;
  background-color: #d8d8d8;
}

.section-title {
  margin-bottom: 25px;
  text-align: left;
}

.section-title h3 {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
  text-indent: 0;
}

.section-title .subtitle {
  font-size: 18px;
  color: #666;
  text-indent: 0;
  font-style: italic;
  line-height: 1.4;
  margin-bottom: 20px;
}

.text-content p {
  margin: 0 0 15px 0;
  line-height: 1.8;
  color: #333;
  text-indent: 2em;
}

.gallery {
  padding: 20px 0;
}

.full-width-image {
  width: 100%;
  display: block;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

/* 轮播图自定义样式 */
:deep(.el-carousel__container) {
  height: 400px;
}

:deep(.el-carousel__item) {
  height: 100%;
}

:deep(.el-carousel__indicators) {
  bottom: 20px;
}

:deep(.el-carousel__button) {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.7);
}

:deep(.el-carousel__arrow) {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  width: 40px;
  height: 40px;
}

:deep(.el-carousel__arrow:hover) {
  background-color: rgba(0, 0, 0, 0.5);
}

:deep(.el-carousel__indicators--outside) {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}

:deep(.el-carousel__indicator.is-active .el-carousel__button) {
  background-color: #fff;
  transform: scale(1.2);
}

@media screen and (max-width: 768px) {
  .content {
    padding: 12px 0 24px;
    min-height: auto;
  }

  .page-content {
    flex-direction: column;
    gap: 16px;
    margin-top: 12px;
  }

  .left-nav {
    width: 100%;
    position: static;
    max-height: none;
    padding: 12px;
    overflow: visible;
  }

  .left-nav ul {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .left-nav li {
    flex-shrink: 0;
    padding: 8px 12px;
    white-space: nowrap;
  }

  .section {
    padding: 16px;
    margin-bottom: 16px;
  }

  .section-title h3 {
    font-size: 20px;
  }

  .section-title .subtitle {
    font-size: 14px;
  }

  :deep(.el-carousel__container) {
    height: 200px !important;
  }
}

@media screen and (max-width: 480px) {
  .section-title h3 {
    font-size: 18px;
  }

  :deep(.el-carousel__container) {
    height: 160px !important;
  }
}
</style> 